import React from "react";

const PaymentDetail = ({varShowDetail,varDetailInfo,ClosePaymentDetail,onPaymentLastYearListHandler,onRefundHandler}) => {

  return (
    <div className={varShowDetail?"layer__pop open":"layer__pop"}>
      <div className="layer__pop__confirm" style={{maxWidth:"500px"}}>
        <div className="layer__bottom__head mb15">
          <div className="layer__pop__title" style={{paddingTop:"20px"}}>결제 현황</div>
          <div className="layer__pop__close" onClick={()=>ClosePaymentDetail()}></div>
        </div>
        <div className="layer__pop__body" style={{marginTop:"10px"}}> 
          <div className="main-box">
            <table className="write-s">
              <colgroup><col width="30%"></col><col width="70%"></col></colgroup>
              <thead></thead>
              <tbody>
                <tr><th>순서</th><td>{varDetailInfo.nums}</td></tr>
                <tr><th>센터명</th><td>{varDetailInfo.bh_company}</td></tr>
                <tr><th>금액(원)</th><td>{varDetailInfo.ph_price}</td></tr>
                <tr><th>결제일</th><td>{varDetailInfo.ph_pdate}</td></tr>
                <tr>
                  <th>결제상태</th>
                  <td>
                    {varDetailInfo.ph_state} &nbsp;&nbsp;
                    {varDetailInfo.ph_status===4?<button className="btn small" style={{width:"90px"}} onClick={e=>onRefundHandler(e)} >환불완료</button>:null}
                  </td>
                </tr>
                <tr><th>결제정보</th><td>{varDetailInfo.ch_name}</td></tr>
                <tr><th>개월</th><td>{varDetailInfo.ch_month}</td></tr>
                <tr><th>생년월일</th><td>{varDetailInfo.ch_birthday}</td></tr>
                <tr><th>결제학기</th><td>{varDetailInfo.cl_name}</td></tr>
                <tr><th>학부모(연락처)</th><td>{varDetailInfo.mem_name}({varDetailInfo.mem_mobile})</td></tr>
                <tr><th>차수</th><td>{varDetailInfo.pass_cnt}/{varDetailInfo.tstudys}</td></tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="btn-center" style={{display:"flex",justifyContent:"space-between"}}>
          <button onClick={e=>onPaymentLastYearListHandler(e,varDetailInfo)} style={{width:"200px"}} className="btn line">기존 결제 내역 (최근 1년)</button>
          <button onClick={()=>ClosePaymentDetail()} style={{width:"90px"}} className="btn line black">닫기</button>
        </div>
      </div>

    </div> 
  )
}
export default PaymentDetail;